
import { useContext } from 'react';
import { Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import Moment from 'react-moment';
import { ticketContext } from 'views/Ticket/TicketContext';

let MagicDates = () => {
    let { ticket } = useContext(ticketContext);

    return (
        <Grid item xs={12}>
            <Grid container>
                <Grid item xs style={{ backgroundColor: '#efefef' }}>
                    <Typography variant="h5">Important dates</Typography>
                </Grid>
            </Grid>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Customer Service Assigned On</TableCell>
                        <TableCell>Resolved On</TableCell>
                        <TableCell>Cancelled On</TableCell>
                        <TableCell>Closed On</TableCell>
                        <TableCell>Completed On</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow >
                        <TableCell>{ticket.customerServiceAssignedOn != null ? <Moment date={ticket.customerServiceAssignedOn} format="ll" /> : <>-</>}</TableCell>
                        <TableCell>{ticket.resolvedOn != null ? <Moment date={ticket.resolvedOn} format="ll" /> : <>-</>}</TableCell>
                        <TableCell>{ticket.cancelledOn != null ? <Moment date={ticket.cancelledOn} format="ll" /> : <>-</>}</TableCell>
                        <TableCell>{ticket.closedOn != null ? <Moment date={ticket.closedOn} format="ll" /> : <>-</>}</TableCell>
                        <TableCell>{ticket.completedOn != null ? <Moment date={ticket.completedOn} format="ll" /> : <>-</>}</TableCell>
                    </TableRow>
                </TableBody>

            </Table>
        </Grid>
    )
}

export default MagicDates;